import { SIGNUP } from '@/features/auth/services'
import { clearStoredReferralData, getReferralDataForAuth } from '@/features/save-log'
import { getRefCookies } from '@/libs/cookies'
import { fetchWithToken } from '@/services/fetcher'
import yup from '@/utils/yup-global'
import { registerSchema } from '@/validations'
import { LoginAction } from './login'

export const RegisterAction = async (values: yup.InferType<typeof registerSchema>) => {
  try {
    const input = {
      firstname: '.',
      email: values?.email,
      lastname: values?.lastname,
      password: values?.password,
      phone_number: values?.mobile_phone,
      // country_code: 'VN',
    }

    // Lấy referral code từ cookies (nếu có)
    const refParams = await getRefCookies()
    if (refParams) {
      Object.assign(input, { new_parent_referral_code: refParams })
    }

    // Lấy referral tracking data từ localStorage (nếu có)
    const referralData = getReferralDataForAuth()
    if (referralData) {
      Object.assign(input, {
        meta_log: JSON.stringify(referralData), // Full data dạng JSON string
        referral_source: referralData.referral_source || '',
        target_url: referralData.target_url || '',
        camp: referralData.camp || '',
        adsid: referralData.adsid || '',
        platform: referralData.platform || '',
        referral_type: referralData.referral_type || '',
      })
    }

    const response = await fetchWithToken({
      query: SIGNUP,
      variables: {
        input: input,
      },
    }).then((res) => res?.payload)

    const isSuccess = response?.data?.createCustomerV2?.customer
    if (!isSuccess) {
      // Return serializable error object
      return {
        status: 'error' as const,
        message: response?.errors?.[0]?.debugMessage || response?.errors?.[0]?.message || "something's wrong",
      }
    }

    // Clear referral data sau khi đăng ký thành công
    if (referralData) {
      clearStoredReferralData()
      console.log('[Register] Cleared referral data after successful signup')
    }

    // Return serializable success object
    return {
      status: 'success' as const,
      message: 'Register successfully',
      data: {
        customer: isSuccess,
      },
    }
  } catch (err) {
    console.error('Register action error:', err)
    // Return serializable error object
    return {
      status: 'error' as const,
      message: "something's wrong",
    }
  }
}

/**
 * Action để đăng ký và tự động đăng nhập
 */
export const RegisterAndLoginAction = async (
  values: yup.InferType<typeof registerSchema>,
  callbackUrl?: string | null
) => {
  try {
    // Bước 1: Đăng ký tài khoản
    const registerResult = await RegisterAction(values)

    if (registerResult?.status === 'error') {
      return {
        status: 'error' as const,
        message: registerResult?.message || 'Không thể đăng ký tài khoản',
      }
    }
    // Bước 2: Tự động đăng nhập với mật khẩu mới
    const loginResult = await LoginAction({ email: values.email, password: values.password }, callbackUrl)

    if (loginResult?.status === 'error') {
      return {
        status: 'error',
        message:
          'Đặt lại mật khẩu thành công, nhưng không thể đăng nhập tự động. Vui lòng đăng nhập thủ công.',
      }
    }
    return {
      status: 'success' as const,
      message: 'Đăng ký và đăng nhập thành công!',
      data: loginResult?.data,
    }
  } catch (error) {
    console.error('Register and login error:', error)
    return {
      status: 'error' as const,
      message: 'Có lỗi xảy ra trong quá trình đăng ký',
    }
  }
}
